import React from 'react';
import { FadeIn } from '../ui/FadeIn';
export function BeneficiosSection() {
  const beneficios = [{
    text: 'Reduce tu dependencia de pastillas con alternativas naturales que sí funcionan',
    icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-10 h-10" data-id="element-140">
          <path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z" data-id="element-141" />
          <polyline points="3 12 7 12 9 8 13 16 15 12 21 12" data-id="element-142" />
        </svg>
  }, {
    text: 'Ahorra dinero usando ingredientes de tu cocina que cuestan centavos',
    icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-10 h-10" data-id="element-143">
          <path d="M12 2.69l5.66 5.66a8 8 0 11-11.31 0z" data-id="element-144" />
          <path d="M9 14l2 2 4-4" data-id="element-145" />
        </svg>
  }, {
    text: 'Recupera tu energía y vitalidad desde la primera semana',
    icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-10 h-10" data-id="element-146">
          <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" data-id="element-147" />
        </svg>
  }, {
    text: 'Mejora tus niveles de presión, azúcar y colesterol de forma natural',
    icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-10 h-10" data-id="element-148">
          <path d="M17 10c.7-.7 1.69-1 2.5-1a3.5 3.5 0 010 7c-.81 0-1.8-.3-2.5-1-.7.7-1.69 1-2.5 1a3.5 3.5 0 010-7c.81 0 1.8.3 2.5 1zM7 14c-.7.7-1.69 1-2.5 1a3.5 3.5 0 010-7c.81 0 1.8.3 2.5 1 .7-.7 1.69-1 2.5-1a3.5 3.5 0 010 7c-.81 0-1.8-.3-2.5-1z" data-id="element-149" />
          <path d="M9.5 8.5l5 5M9.5 15.5l5-5" data-id="element-150" />
        </svg>
  }, {
    text: 'Reduce inflamación y dolor articular con anti-inflamatorios naturales',
    icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-10 h-10" data-id="element-151">
          <path d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z" data-id="element-152" />
          <polyline points="15 4 19 4 15 8 19 8" data-id="element-153" />
          <polyline points="18 12 22 12 18 16 22 16" data-id="element-154" />
        </svg>
  }, {
    text: 'Fortalece tu cuerpo y frena el deterioro con protocolos inmunológicos naturales',
    icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-10 h-10" data-id="element-155">
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" data-id="element-156" />
          <path d="M12 8c-2.5 0-4 1.5-4 4s1.5 4 4 4 4-1.5 4-4-1.5-4-4-4z" data-id="element-157" />
          <path d="M12 8v8" data-id="element-158" />
        </svg>
  }];
  return <section className="bg-ancestral-green py-10 md:py-24 text-ancestral-cream" data-id="element-159">
      <div className="container mx-auto px-4" data-id="element-160">
        <div className="max-w-5xl mx-auto" data-id="element-161">
          <FadeIn data-id="element-162">
            <h2 className="text-2xl md:text-4xl lg:text-5xl font-serif font-bold text-ancestral-gold mb-6 md:mb-12 text-center leading-tight" data-id="element-163">
              Lo Que Este Libro Puede Hacer Por Ti en{' '}
              <span className="text-3xl md:text-5xl lg:text-6xl text-orange-400" data-id="element-164">
                30 Días
              </span>
            </h2>
          </FadeIn>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-6 mb-8 md:mb-12" data-id="element-165">
            {beneficios.map((beneficio, idx) => <FadeIn key={idx} delay={0.1 * idx} data-id="element-166">
                <div className="bg-white/5 border border-ancestral-gold/20 p-4 md:p-6 rounded-2xl flex items-center gap-3 md:gap-5 h-full hover:border-ancestral-gold/50 transition-colors" data-id="element-167">
                  <div className="text-ancestral-gold flex-shrink-0" data-id="element-168">
                    {beneficio.icon}
                  </div>
                  <p className="text-base md:text-xl font-light leading-snug" data-id="element-169">
                    {beneficio.text}
                  </p>
                </div>
              </FadeIn>)}
          </div>

          <FadeIn delay={0.6} data-id="element-170">
            <p className="text-center text-lg md:text-xl font-serif italic text-ancestral-gold/80" data-id="element-171">
              Miles de personas ya están experimentando estos resultados.
            </p>
          </FadeIn>
        </div>
      </div>
    </section>;
}